module.exports = "<div class=\"main-nav-wrap\" ng-transclude>\n\t\n</div>\n<!-- .main-nav-wrap END -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpMainNavigation/adpMainNavigation.html
// module id = 603
// module chunks = 0